import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac42408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BoxList" }
const _hoisted_2 = { class: "BoxImage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BoxGap" }, null, -1))
const _hoisted_4 = { class: "Text" }
const _hoisted_5 = { class: "Title" }
const _hoisted_6 = { class: "Caption" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "BoxGap" }, null, -1))
const _hoisted_8 = { class: "Text" }
const _hoisted_9 = { class: "Caption" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_OverviewBox = _resolveComponent("OverviewBox")!

  return (_openBlock(), _createBlock(_component_OverviewBox, {
    class: "ResaleBox",
    link: {
      icon: 'resale',
      to: 'Resale',
      title: _ctx.mixWB(`VIEW_RESALE_CATALOGUE`),
    }
  }, _createSlots({
    subHeader: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.data.subheader), 1)
    ]),
    list: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.list, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: item.hashID
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Image, {
                image: item.types[0].images[0],
                dimensions: {width: 40, height: 40},
                transformation: 'square_40'
              }, null, 8, ["image"])
            ]),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.titles.category) + " - " + _toDisplayString(item.titles.types), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.unitsAsString), 1)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.mixWB('QUANTITY_2')), 1),
              _createElementVNode("span", null, _toDisplayString(item.getAmountData().asText), 1)
            ])
          ], 64))
        }), 128))
      ])
    ]),
    _: 2
  }, [
    (!_ctx.data.list.length)
      ? {
          name: "noData",
          fn: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(_ctx.mixWB('NO_RESALE_ITEMS_FOUND')), 1)
          ])
        }
      : undefined
  ]), 1032, ["link"]))
}